import {
    IonButton, IonCheckbox, IonCol, IonContent, IonGrid, IonInput, IonItem, IonLabel, IonPage, IonRadio, IonRadioGroup, IonRow, IonSelect,
    IonSelectOption, IonText, useIonViewDidLeave, useIonViewWillEnter
} from "@ionic/react";
import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";

import { Link } from "react-router-dom";
import Footer from "../../../components/Footer";
import UserTerms from "../../../components/UserTerms";
import { User } from "../../../models/data";
import { translation } from "../../../models/translation";
import { fetchOrg, fetchOrgList } from "../../../services/org_service";

interface Props {
    user: User
}


interface DonateForm {
    pickOrg: string | null,
    altOrg: string | null,
    date: string,
    freq: string,
    amount: number,
    tip:number,
    anom: boolean,
    beneficiary_type: string
}
const DonateToOrgPms: React.FC<Props> = ({user }) => {

    const history = useHistory();

    const location = useLocation()

    const siteText = translation();

    const lan = siteText.lan.replace("/", "")

    const [orgList, setOrgList] = useState<any[]>();

    const params = new URLSearchParams(location.search)

    const OrgId = params.get('id');

    const state:any= location.state;

    const tomorrow = new Date();

    tomorrow.setDate(new Date().getDate() + 1);

    const year = tomorrow.getFullYear();

    let month = `${tomorrow.getMonth() + 1}`;
    let day = `${tomorrow.getDate()}`;

    if (month.length < 2) { month = 0 + month };
    if (day.length < 2) { day = 0 + day };

    const minDate = `${year}-${month}-${day}`;

    const tips = [
        {
            name: 'none',
            value: 0.00,
            label: '0%'
        },
        {
            name: 'basic',
            value: 0.03,
            label: '3%'
        },
        {
            name: 'middle',
            value: 0.05,
            label: '5%'
        },
        {
            name: 'basic',
            value: 0.07,
            label: '7%'
        }
    ]

    const [tip, setTip] = useState<number>(() => {
        return tips[2].value
    });

    const [amount, setAmount] = useState(() => { return 0 })
    const [orgChoice, setOrgChoice] = useState({
        pickOrg: 'other',
    });

    const [anonymous, setAnonymous] = useState(false)

    const [donateData, setDonateData] = useState<DonateForm>({
        pickOrg: null,
        altOrg: null,
        date: minDate,
        freq: 'single',
        amount: 0,
        tip:0,
        anom: false,
        beneficiary_type: "other"
    })

    const [org, setOrg] = useState<any>()
    const [orgPage, setOrgPage] = useState<any>()



    const [terms, agreeTerms] = useState(false);

    const [userTerms, showUserTerms] = useState<boolean>(false);

    useIonViewDidLeave(() => {
        setOrg(null)
        setOrgPage(null)
    })

    useIonViewWillEnter(() => {
        if (OrgId) getOrg()
    }, [OrgId])

    useEffect(() => {
        getOrgList();
        return () => { };
    }, [])

    const getOrgList = async () => {
        let orgs = await fetchOrgList();
        setOrgList(orgs.message);
    }

    const getOrg = async () => {
        let orgPage = await fetchOrg(OrgId)
        setOrg(orgPage.message.acf[lan].rel_org)
        setOrgPage(orgPage.message)
        setOrgChoice({ pickOrg: orgPage.message.acf[lan].rel_org.ID })
    }

    const updateOrg = (value: any) => {
        setOrgChoice({ pickOrg: value })
        if (value !== "other") {
            let form = donateData;
            form.beneficiary_type = 'organisation';
            form.altOrg = null;
            form.pickOrg = value;
            setDonateData(form);
        } else {
            let form = donateData;
            form.pickOrg = null;
            form.beneficiary_type = "other";
            form.altOrg = value;
            setDonateData(form);
        }
    }


    /*Close open user terms  */
    const toggleUserTerms = () => {
        let current = userTerms;
        showUserTerms(!current);
    }
    const commissionToCash = (value: any) => {
        let commission = amount * value
        commission = Math.round(commission * 100) / 100
        return commission
    }

    const amountSummary = (amount: any, commission: any) => {
        let summary = +amount + (amount * commission)
        summary = Math.round(summary * 100) / 100
        return summary
    }

    const onSubmit = (event: any) => {
        event.preventDefault();
        if (!amount) return
        donateData.amount = (+amount + (amount * tip))
        donateData.tip=tip*amount
        donateData.anom = anonymous
        let state = {
            data: donateData
        }
        history.push(`/${lan}/account/donate_process_V2`, state);


    }
    return (
        <IonPage>
            <IonContent>

                {!userTerms ?
                    <IonGrid className="innerBody">
                        <IonRow >
                            <IonCol className="ion-margin-top" offsetSm="1" sizeSm="10" sizeMd="8">
                                {!OrgId && <h1 className="h2">{siteText.donateDirectlyStartTitle}</h1>}
                                {orgPage && <h1 className="h2">{siteText.fundraiseDonateStartTitle.replace("%%title%%", orgPage.title.rendered)}</h1>}

                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol className="ion-margin-top" offsetSm="1" sizeSm="10" sizeMd="8">
                                <form onSubmit={e => onSubmit(e)}>

                                    <IonLabel position="stacked">{siteText.donateDirectlyStartAmountLabel}</IonLabel>
                                    <IonInput className="ion-margin-bottom ion-margin-top" value={amount} onIonChange={(e: any) => setAmount(+e.detail.value)} placeholder={siteText.donateDirectlyStartAmountPlh} min="0" type="number"></IonInput>
                                    <h4>{siteText.donateDirectlyPaySubtotalText} {amount ? amountSummary(amount, tip) : 0} CHF</h4>

                                    <p>{siteText.donateDirectlyPayTipRequest}</p>
                                    <IonRadioGroup style={{ display: 'flex' }} className="ion-margin-bottom" value={tip} onIonChange={(e: any) => setTip(e.detail.value)}>
                                        {tips.map((m, key) => <IonItem className="ion-margin-end" lines="none" key={key}><IonLabel className="ion-margin-end">{commissionToCash(m.value)} CHF</IonLabel> <IonRadio value={m.value}></IonRadio></IonItem>)}
                                    </IonRadioGroup>

                                    {!OrgId &&
                                        <>
                                            <IonLabel position="stacked">{siteText.donateDirectlyStartBeneficiaryLabel}</IonLabel>
                                            <IonSelect mode="md" interface="popover"  disabled={(OrgId && OrgId?.length > 0 )? true : false} className="ion-margin-bottom ion-margin-top" value={orgChoice.pickOrg} okText={siteText.donateDirectlyStartBeneficiaryConfirm} cancelText={siteText.donateDirectlyStartBeneficiaryCancel} onIonChange={(e) => updateOrg(e.detail.value)}>
                                                <IonSelectOption value="other">{siteText.donateDirectlyStartBeneficiaryInputOpt}</IonSelectOption>
                                                {orgList?.map((m: any, key) => {
                                                    return <IonSelectOption key={key} value={m.id} dangerouslySetInnerHTML={{ __html: m.title.rendered }}></IonSelectOption>
                                                })}


                                            </IonSelect>
                                        </>
                                    }
                                    {
                                        (orgChoice.pickOrg === 'other')
                                            ? (<>
                                                {(state && state.gifting) && 
                                                <>
                                                <IonLabel position="stacked">{siteText.donateGiftLabel}</IonLabel>
                                                <IonInput disabled className="ion-margin-bottom ion-margin-top" value={`${state.fName} ${state.name}`} required={(orgChoice.pickOrg === "other") ? true : false}></IonInput>
                                                </>

                                                }
                                                {
                                                    (!state || !state.gifting) &&
                                                    <>
                                                <IonLabel position="stacked">{siteText.donateDirectlyStartBeneficiarySuggest}
                                                </IonLabel>
                                                <IonInput className="ion-margin-bottom ion-margin-top" placeholder={siteText.donateDirectlyStartBeneficiarySuggestPlh} required={(orgChoice.pickOrg === "other") ? true : false}></IonInput>
                                                    </>
                                                }
                                            </>)
                                            : ''
                                    }

                                    <IonItem lines="none" className="borderedInput">
                                        <IonLabel>
                                            {siteText.donateDirectlyStartAnonymousCheck}
                                        </IonLabel>
                                        <IonCheckbox checked={anonymous} onIonChange={(e: any) => { setAnonymous(e.detail.checked) }} slot="start" />
                                    </IonItem>

                                    <IonCol sizeMd="4">
                                        <IonItem lines="none" className="borderedInput ion-margin-bottom">
                                            <IonLabel className="ion-text-wrap"> <Link to="terms_of_use" onClick={e => { e.preventDefault(); toggleUserTerms(); }}>{siteText.donateDirectlypayConfirm}</Link> </IonLabel>
                                            <IonCheckbox slot="start" checked={terms} onIonChange={() => { agreeTerms(!terms) }} />
                                        </IonItem>
                                    </IonCol>
                                    <IonButton disabled={!terms || amount === 0} strong slot="end" className="ion-margin-top" type="submit">
                                        <IonText color="light">
                                            {siteText.donateDirectlyStartSubmitTxt}
                                        </IonText>
                                    </IonButton>
                                </form>
                            </IonCol>
                        </IonRow>
                    </IonGrid> :
                    <IonGrid className="innerBody">
                        <IonRow>
                            <IonCol offsetSm="1" sizeMd="10" sizeSm="10">
                                <UserTerms goBack={toggleUserTerms}></UserTerms>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                }
                <Footer></Footer>
            </IonContent>

        </IonPage>
    )

}

export default DonateToOrgPms;